import type { ProductData } from "@/mocks/products";

interface Props {
  product: ProductData;
}

export default function UseCasesSection({ product }: Props) {
  return (
    <section className="py-10 md:py-14">
      <div className="w-full px-4 sm:px-6 lg:px-8 xl:px-16">
        <div className="max-w-6xl mx-auto">
          <div className="mb-8 md:mb-10">
            <h2 className="text-2xl md:text-3xl font-bold text-white mb-2">
              Use Cases
            </h2>
            <p className="text-base text-silver-400">
              How organizations use {product.name.replace("StackMap ", "")} to drive results.
            </p>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 gap-5 md:gap-6">
            {product.useCases.map((uc, idx) => (
              <div
                key={uc.title}
                className="glass-card p-6 md:p-7 flex flex-col h-full group"
              >
                <div className="w-8 h-8 flex items-center justify-center rounded-md bg-emerald-accent/10 mb-4">
                  <span className="text-sm font-bold text-emerald-accent">
                    {String(idx + 1).padStart(2, "0")}
                  </span>
                </div>
                <h3 className="text-base font-semibold text-white mb-2 group-hover:text-emerald-soft transition-colors">
                  {uc.title}
                </h3>
                <p className="text-sm text-silver-400 leading-relaxed flex-1">
                  {uc.description}
                </p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}